import { Injectable, Injector } from '@angular/core';
import { BaseService } from '@common-modules/shared/base.service';
import { Observable } from 'rxjs';
import { GroupModelsCrudResponse } from '../models/group-models-crud-response';
import { GroupModelsResponse } from '../models/group-models-response';
import { GroupModelsDto } from '../models/group-models.dto';

@Injectable()
export class GroupModelsService extends BaseService {
  private _entityUrl: string;

  constructor(injector: Injector) {
    super(injector);
    this._entityUrl = `${this.apiUrl}/roles/group-models`;
  }

  getGroupModelsCrudByGroupId(groupId: number): Observable<GroupModelsResponse> {
    return this.httpCacheClient.get(`${this._entityUrl}/${groupId}`);
  }

  postGroupModelsCrud(modelGroupCrud: GroupModelsDto): Observable<GroupModelsCrudResponse> {
    return this.httpCacheClient.post(`${this._entityUrl}`, modelGroupCrud, {
      avoid: true,
    });
  }
}
